export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_04.7d169ac2.jpg";